module.exports = __webpack_public_path__ + "static/media/Icon-mail-orange.86d61f3e.svg";